import React, { Component } from 'react'
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { UpdateUser } from '../../actions';

const INITIAL_FORM = {
    senha: '',
    confirmPassword: '',
}

class ModalUpdatePassword extends Component {
    constructor(props){
        super(props)

        this.state = {
            modalIsOpen: true,
            form: {
               // oldPassword: '',
                senha: '',
                confirmPassword: '',
            }
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSubmitForm = this.onSubmitForm.bind(this);
    }

    openModal() {
        //this.setState({modalIsOpen: true});
        this.props.openModal()
    }

    closeModal() {
        //console.log(this.props)
        this.props.closeModal()
        //this.setState({modalIsOpen: false});
    }

    handleInputChange(event){
        var form = this.state.form
        const { name, value } = event.target
        form[name] = value
        this.setState({ form })
    }

    async onSubmitForm(event){
        event.preventDefault()
        const { userUpdate, user } = this.props.auth
        
        let form = this.state.form
        let userId = null;

        for (let i in form ) {
            if ((form[i]).trim() == '') {
                return alert('Preencha todos os campos! campo ' + i);
            }
        }

        if (form.senha != form.confirmPassword) {
            return alert('Senhas não conferem.');
        }
            
        if (userUpdate) {
            form.cpf = userUpdate.cpfcnpj;
            userId = userUpdate.id;
        } else {
            form.cpf = user.cpfcnpj;
            userId = user.id;
        }

        this.props.UpdateUser({id: userId, ...form}, async res => {
            if(res) {
                await this.setState({ form: {...INITIAL_FORM} })
                try{
                    await Array.from( document.querySelectorAll('form#updatePassword input') ).map( input => input.value = '')

                    if(document.querySelector('#modalUpdatePassword .close'))
                        document.querySelector('#modalUpdatePassword .close').click()

                    toast.success('Usuário atualizado com sucesso!')
                } catch (error) {
                    console.log('ERROR',error)
                }
                
            }
        })
    }

    render(){
        const { loading_auth, error_cadastro, msg_cadastroUser, userUpdate } = this.props.auth
        return(
            <div className="modal fade" id="modalUpdatePassword" tabIndex="-1" role="dialog" aria-labelledby="modalAddUser"
            aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <form id="updatePassword" className="form-signin" onSubmit={this.onSubmitForm} style={{ textAlign: 'left'}}>

                        <button style={{ position:'absolute', right: 30 }} type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>

                        <h1 className="h3 mb-3 font-weight-normal" style={{ textAlign: 'center'}}>
                            Atualizar Senha { userUpdate ? `(${userUpdate.nome})` : ''}
                        </h1>

                        {/* <div className="form-group">
                            <label  className="">Senha antiga:</label>
                            <input name="oldPassword" type="password" className="form-control" placeholder="Senha antiga" required onChange={this.handleInputChange} />
                        </div> */}

                        <div className="form-group">
                            <label  className="">Nova senha</label>
                            <input name="senha" type="password" className="form-control" placeholder="Nova senha" required onChange={this.handleInputChange} />
                        </div>

                        <div className="form-group">
                            <label  className="">Confirme a senha</label>
                            <input name="confirmPassword" type="password" className="form-control" placeholder="Confirme a senha" required onChange={this.handleInputChange} />
                        </div>

                        <button className="btn btn-lg btn-primary btn-block" type="submit" role="button" disabled={loading_auth}>
                            {loading_auth ?<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                            {loading_auth ? '   Aguarde...' : 'Atualizar'}
                        </button>

                    </form>

                        {/* {msg_cadastroUser != ''
                            ?<div className={`alert alert-${error_cadastro ? 'danger' : 'success'}`} role="alert" style={{marginTop:'1%'}}>
                                {msg_cadastroUser}
                            </div>
                            :null
                        } */}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ auth }) => {
    return {
        auth
    }
}

export default connect(mapStateToProps, {
    UpdateUser
})(ModalUpdatePassword);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        // height: '50%',
        left:'35%',
        top: '80px',
    }
}